// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__FazEz","link":"Navigation_link__FQmyO","activeLink":"Navigation_activeLink__18fuJ"};